import { TCampaignApi } from '@pages/campaigns/campaigns.interface';
import { IDateRangeBounds } from '@shared/components/profile-date-filter/profile-date-filter.interface';
import { endOfDay, isAfter, isBefore, max, min, startOfDay } from 'date-fns';

/**
 * Widens the selected range so a campaign running on its first or last day is never cut off
 * mid-campaign: the start moves back to the earliest such campaign's start, the end forward to
 * the latest such campaign's end (never past today, there's no data after it). Never shrinks.
 */
export function widenDateRangeToRunningCampaigns(
  range: IDateRangeBounds,
  campaigns: TCampaignApi[],
  now: Date = new Date(),
): IDateRangeBounds {
  const today = endOfDay(now);
  let { end, start } = range;

  for (const campaign of campaigns) {
    const campaignStart = campaign.start as Date;
    const campaignEnd = campaign.end as Date;

    if (isBefore(campaignStart, range.start) && !isBefore(campaignEnd, range.start)) {
      start = min([start, startOfDay(campaignStart)]);
    }

    if (!isAfter(campaignStart, range.end) && isAfter(campaignEnd, range.end)) {
      end = max([end, min([endOfDay(campaignEnd), today])]);
    }
  }

  return { end, start };
}
